import { Check, type CheckProps } from '@hover/blueprint';
import React from 'react';

interface StyledCheckProps extends CheckProps {
  isChecked: boolean;
}

export const StyledCheck: React.FC<StyledCheckProps> = ({
  isChecked,
  ...props
}) => (
  <Check
    color="neutral.900"
    fill="none"
    height={100}
    isChecked={isChecked}
    marginLeft={100}
    stroke="black"
    strokeWidth="4px"
    width={100}
    {...props}
  />
);
